import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useShop } from '@/contexts/ShopContext';

export interface ShopDetail {
  id: string;
  name: string;
  currency: string;
  timezone?: string | null;
  country?: string | null;
  category?: string | null;
  sub_category?: string | null;
  custom_activity?: string | null;
  taxonomy?: {
    axis: string;
    activity: string;
    custom_activity: string | null;
    version: number;
  } | null;
  directory_category_key?: string | null;
  city?: string | null;
  description?: string | null;
  allow_negative_stock: boolean;
  reserve_pending_pos_stock?: boolean;
  allow_employee_price_override: boolean;
  drivers_enabled: boolean;
  team_unified_enabled?: boolean;
  payroll_enabled?: boolean;
  accounting_enabled?: boolean;
  delivery_reminders_enabled?: boolean;
  delivery_reminder_time?: string;
  receipt_show_discounts?: boolean;
  receipt_show_barcode?: boolean;
  // Module Retours (RR-01 — toggled per shop)
  returns_enabled?: boolean;
  returns_window_days?: number;
  return_approval_threshold?: number | null;
  returns_restock_default?: boolean;
  returns_allow_store_credit?: boolean;
  returns_allow_exchange?: boolean;
  // Module Bar / Contrôle + Partenaire (toggled per shop)
  bar_mode_enabled?: boolean;
  ingredient_management_enabled?: boolean;
  partner_mode_enabled?: boolean;
  commerce_pages_enabled?: boolean;
  landed_cost_v1?: boolean;
  tracked_stock_transfers_v1?: boolean;
  slug?: string | null;
  // Module Troc / Reprise
  barter_enabled?: boolean;
  // Hébergement & Location — capability déclarée par le serveur.
  rental_mode_enabled?: boolean;
  rental_profile?: 'hotel' | 'motel' | 'furnished' | 'rental_property' | null;
  // Other fields exist; we only type the ones consumed by sidebar/POS.
  [key: string]: unknown;
}

export function useCurrentShopDetail() {
  const { currentShop } = useShop();
  const shopId = currentShop?.id ?? '';

  return useQuery({
    queryKey: ['shop-detail', shopId],
    enabled: Boolean(shopId),
    queryFn: () => api.get<ShopDetail>(`/shops/${shopId}`),
    staleTime: 60_000,
  });
}
